// ABOUTME: The seeded welcome message every fresh conversation starts with, and
// whether a conversation is still pristine (only that message), when ChatSurface
// offers the business's own ideas beside it. The greeting never mentions them, so it
// stays true when there are none.
// One constant, one builder — createConversation and clearConversation used to
// carry duplicate inline copies of this message, which is how the copy drifts.

import type { AIChatMessage, AIConversation } from '@/stores/aiChatTypes'

export const WELCOME_MESSAGE_ID = 'welcome'

const WELCOME_MESSAGE_CONTENT =
  "Hi! I'm your AI marketing assistant. I can write and schedule your social posts, " +
  'create promotional images, and show you which content brings in leads. ' +
  'What would you like to work on?'

export function buildWelcomeMessage(timestamp: string): AIChatMessage {
  return {
    id: WELCOME_MESSAGE_ID,
    role: 'assistant',
    content: WELCOME_MESSAGE_CONTENT,
    timestamp,
  }
}

/**
 * A conversation is pristine while its only message is the seeded welcome —
 * the state in which ideas help and after which they would be noise.
 */
export function isPristineConversation(conversation: AIConversation | null): boolean {
  return (
    !!conversation &&
    conversation.messages.length === 1 &&
    conversation.messages[0].id === WELCOME_MESSAGE_ID
  )
}
